export const environment = {
  production: false,
  apiUrl: "/api",
  ssoUrl: "https://login.microsoftonline.com/a1a72d9c-49e6-4f6d-9af6-5aafa1183bfd/oauth2/v2.0",
  clientId: "51213f98-4585-4f54-a09b-eae7c44299a7",
  redirectUrl: "https://test.db-fejlmelding.dk/api/login/oauth2",
  openIdConfiguration: "",
  installerName: "https://sa0dbc0test0001.blob.core.windows.net/admin-artifacts/Fejlmelding-Admin.exe"
};
